var map = {
	"./a_cuentas_corrientes.png": "9356",
	"./a_cuentas_corrientes2.png": "f17f",
	"./cantidad_ventas.png": "17ca",
	"./comprado.png": "2f47",
	"./deuda-clientes.png": "1445",
	"./devoluciones.png": "b9a7",
	"./gastos.png": "0ca8",
	"./ingresos-netos.png": "821c",
	"./ingresos_brutos.png": "d4eb",
	"./ingresos_netos.png": "f9e6",
	"./iva_comprado.png": "c880",
	"./iva_diferencia.png": "4bb5",
	"./iva_vendido.png": "a949",
	"./pagado.png": "6bdb",
	"./pagado_mostrador.png": "ca68",
	"./pagado_mostrador2.png": "ca76",
	"./productos.png": "4ba96",
	"./rentabilidad.png": "965f",
	"./ventas.png": "624a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "074f";